let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9TQXS")).then(() => parcelRequire('ftRur'));